import { AGREEMENT_STATE } from "astrid-functions/src/functions/scrive/agreement/constants";

import createApprovalData from "../approval/createApprovalData";

import agreementStatuses from "./constants/agreementStatuses";
import createAgreementTemplate from "./createAgreementTemplate";
import createTerminationData from "./createTerminationData";
import { Agreement } from "./types/Agreement";

function withVendor(party, vendorId) {
	const vendor = party?.vendors?.[vendorId];

	return vendor ? { ...party, vendor: { id: vendorId, ...vendor } } : party;
}

export default function createAgreementData(firebase, data) {
	const {
		approved = null,
		template = null,
		producer = null,
		createdBy = null,
		publisher = null,
		production = null,
		activeFrom = new Date(),
		firstParty = null,
		secondParty = null,
		firstSignee = null,
		firstPartyVendorId = null,
		secondPartyVendorId = null,
		signedAgreementFile = null,
	} = data;

	const db = firebase.firestore();
	const ref = data.ref || db.collection("agreements").doc();

	const producerRef =
		(production?.producer
			? {
					id: production.producer,
					ref: db.collection("organizations").doc(production.producer),
					name: production.producerName,
					type: "producer",
			  }
			: producer) ??
		template?.producer ??
		null;

	const { life, ...templateData } = createAgreementTemplate(firebase, {
		...template,
		...data,
		producer: producerRef,
	});

	activeFrom.setHours(0, 0, 0, 0);

	const expires = new Date(activeFrom);

	const today = new Date();

	expires.setDate(activeFrom.getDate() + parseInt(life));

	return Agreement.parse({
		...templateData,
		id: ref.id,
		ref,
		life,
		state: signedAgreementFile ? AGREEMENT_STATE.SIGNED : AGREEMENT_STATE.CREATED,
		// check if agreement is singed and also if the activeFrom date has passed
		status: signedAgreementFile
			? activeFrom <= today
				? agreementStatuses.ACTIVE
				: agreementStatuses.SIGNED
			: agreementStatuses.PENDING_APPROVAL,
		expires: firebase.firestore.Timestamp.fromDate(expires),
		activeFrom: firebase.firestore.Timestamp.fromDate(activeFrom),
		signedAgreementFile,
		initiatedSigning: false,
		template: template,
		producer: producerRef,
		publisher: production?.publisher
			? {
					id: production.publisher,
					ref: db.collection("organizations").doc(production.publisher),
					name: production.publisherName,
					type: "publisher",
			  }
			: publisher,
		createdBy: createdBy,
		production: production,
		firstParty: withVendor(firstParty, firstPartyVendorId),
		secondParty: withVendor(secondParty, secondPartyVendorId),
		firstSignee: firstSignee,
		secondSignee: secondParty.signee || secondParty,
		termination: createTerminationData(),
		approval: createApprovalData(approved || null, createdBy),
	});
}
